var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1477 39L25.9477 10.2H34.0677L42.8677 39H37.2677L29.4277 13.6H30.4677L22.7477 39H17.1477ZM22.4277 33V27.92H37.6277V33H22.4277Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5001 61.3148C43.5001 54.377 33.4769 50.7962 30.094 44.3619L29.9687 44.25L29.9061 44.3619C26.5233 50.7962 16.5001 54.377 16.5001 61.3148C16.5001 67.1337 25.0824 69.3717 29.2796 64.504C29.3423 64.2802 29.2796 66.0706 28.9664 67.0777C27.9641 70.0431 24.3307 74.4072 22.5766 75.75C25.0198 73.9036 34.8551 73.9036 37.2982 75.75C35.5441 74.4072 32.0987 70.2109 30.9084 67.0777C30.6578 66.1825 30.5325 65.3432 30.4699 64.448C34.6045 69.7074 43.5001 67.2456 43.5001 61.3148Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs);
export default __webpack_public_path__ + "static/media/as.dd8501bc4ba187f4659e4e92e943e2b3.svg";
export { ForwardRef as ReactComponent };